import Account from 'modules/Account';
export const isAuthenticated = (state)=>Account.selectors.isAuthenticated(state);
export const getDefaultRoute = (state)=>Account.selectors.defaultRoute(state);
